import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO/SEO";

const NotFoundPage: React.FC = () => (
  <>
    <SEO
      title="404 – Page Not Found | GS Limo Elite"
      description="The requested page could not be found. Return to GS Limo Elite's transportation services or call (929) 452-6031."
      canonical="/404"
      noIndex
    />
    <section
      className="services-page-section pb-5 text-center"
      style={{ paddingTop: "8rem" }}
    >
      <div className="container gs-anim">
        <p className="section-badge">404</p>
        <h1 className="section-title">Page Not Found</h1>
        <p style={{ maxWidth: "600px", margin: "1rem auto 0" }}>
          Sorry, the page you are looking for doesn't exist or may have been
          moved. Let us get you back on the road.
        </p>
        <div
          className="d-flex justify-content-center flex-wrap gap-3 mt-4"
        >
          <Link to="/" className="btn gs-btn-gold" title="GS Limo Elite – Home">
            <i className="fas fa-home me-2"></i>Back to Home
          </Link>
          <Link
            to="/services"
            className="btn gs-btn-outline-gold"
            title="View All Services"
          >
            <i className="fas fa-car me-2"></i>View Services
          </Link>
        </div>
      </div>
    </section>
  </>
);

export default NotFoundPage;